import React, { createContext, useContext, useMemo } from 'react'
import { JoinToSpeakIDSearchParamName } from '../constants'
import useSearchParams from '../../hooks/useSearchParams'
import { useOnExpired } from '../messaging'
import type {
  JoinToSpeakSpeakerContextValue,
  JoinToSpeakSpeakerProviderProps,
} from './types'
import { useHasJoinedToSpeak } from '../session-storage-hooks'

const JoinToSpeakSpeakerContext =
  createContext<JoinToSpeakSpeakerContextValue | null>(null)

const JoinToSpeakSpeakerProvider = ({
  sessionId,
  children,
}: JoinToSpeakSpeakerProviderProps) => {
  const searchParams = useSearchParams()
  const joinToSpeakID = searchParams.get(JoinToSpeakIDSearchParamName)
  const [, setHasJoinedToSpeak] = useHasJoinedToSpeak(sessionId)

  useOnExpired((message) => {
    if (message.data.joinToSpeakID === joinToSpeakID) {
      const url = new URL(message.data.roomLink)
      url.searchParams.set('ff', '1')
      setHasJoinedToSpeak(true)
      window.location.href = url.toString()
    }
  })

  const context = useMemo<JoinToSpeakSpeakerContextValue>(() => ({}), [])

  return (
    <JoinToSpeakSpeakerContext.Provider value={context}>
      {children}
    </JoinToSpeakSpeakerContext.Provider>
  )
}

function useJoinToSpeakAsSpeaker() {
  const context = useContext(JoinToSpeakSpeakerContext)

  if (context === null) {
    throw new Error(
      'useJoinToSpeakAsSpeaker must be used within a JoinToSpeakSpeakerProvider'
    )
  }

  return context
}

export { JoinToSpeakSpeakerProvider, useJoinToSpeakAsSpeaker }
